import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '@src/environments/environment';
import {from, Observable} from "rxjs";
import {switchMap} from "rxjs/operators";
import {SingleResult} from "@app/interfaces";
import {Upload} from "@app/interfaces/entities/upload";

@Injectable({
  providedIn: 'root'
})
export class UploadApiService {

  constructor(private httpClient: HttpClient) {
  }

  upload(files: File[]) {
    return this.postFile(`${environment.uploadsApiUrl}/api/uploads`, files[0]);
  }

  uploadFile(file: File): Observable<SingleResult<Upload>> {
    return this.postFile<SingleResult<Upload>>(`${environment.uploadsApiUrl}/api/uploads`, file);
  }

  uploadFileNlb(file: File): Observable<SingleResult<Upload>> {
    return this.postFile<SingleResult<Upload>>(`${environment.apiUrl}/api/integrations/nlb/leasing/upload`, file);
  }

  uploadImageFile(file: File): Observable<SingleResult<Upload>> {
    return this.postFile<SingleResult<Upload>>(`${environment.uploadsApiUrl}/api/image-uploads`, file);
  }

  uploadNjuskaloXmlFile(file: File): Observable<SingleResult<Upload>> {
    return this.postFile<SingleResult<Upload>>(`${environment.uploadsApiUrl}/api/uploads/njuskalo`, file);
  }

  // BRIEFD-7436: iOS Safari sends a picked file as an empty part once ngx-dropzone clears its <input>,
  // so read it into memory now (synchronously with the pick) and upload the copy.
  private postFile<T = object>(url: string, file: File): Observable<T> {
    return from(file.arrayBuffer()).pipe(
      switchMap((buffer) => {
        const formData = new FormData();
        formData.append('file', new Blob([buffer], {type: file.type}), file.name);
        return this.httpClient.post<T>(url, formData);
      }),
    );
  }
}
